import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { MaxContext } from './context';
import { subPageBus } from './event';
import { config } from './preference';

/**
 * 缓存页面的渲染方法
 */
export const cacheSubPages = new Map<string, (instanceId: string) => void>();
/**
 * 缓存页面的渲染实例
 */
export const cachePageInstances = new Map<string, any>();

export function create(
  element: (id?: string) => any,
  pageCode: string,
  parentPageCode: string,
  instance: (ele: () => any, leaf: any, type: string) => React.FunctionComponentElement<any>,
  externalId?: string,
) {
  const instanceId = externalId ?? pageCode;

  const App = (props: any) => {
    const { page, pageCode } = props;

    useEffect(() => {
      // 没有缓存的说明没有加载过，需要执行 onReady
      if (!cachePageInstances.has(instanceId)) {
        if (config.isTopCache || page.props?.isCache) {
          cachePageInstances.set(instanceId, page);
        }
        page.onReady?.();
      }
      page.onShow?.();
      return () => {
        page.onUnload?.();
      };
    }, []);

    return (
      <MaxContext.Provider value={{ pageCode, instanceId }}>{instance(() => page, null, 'column')}</MaxContext.Provider>
    );
  };

  let targetKey = '#max-app';
  if (parentPageCode) targetKey = `div#${parentPageCode}`;
  const target = document.querySelector(targetKey);

  if (target) {
    if (cachePageInstances.has(instanceId)) {
      const page = cachePageInstances.get(instanceId);
      if (parentPageCode) {
        setTimeout(() => {
          ReactDOM.render(<App page={page} pageCode={pageCode} />, target);
        }, 100);
      } else {
        ReactDOM.render(<App page={page} pageCode={pageCode} />, target);
      }
    } else {
      const page = element(instanceId);
      ReactDOM.render(<App page={page} pageCode={pageCode} />, target);
    }
  } else {
    subPageBus.addListener(parentPageCode, () => {
      create(element, pageCode, parentPageCode, instance, instanceId);
      subPageBus.removeListener(pageCode);
    });
  }
  cacheSubPages.set(pageCode, (instanceId: string) => create(element, pageCode, parentPageCode, instance, instanceId));
}
